// Compatibility shim. The real implementation now lives in
// /app/frontend/src/lib/PdfDownloadProvider.jsx and is consumed via
// the `usePdfDownload()` hook from inside React components.
//
// This shim exists so non-component code paths (and existing import
// statements that pre-date the v57 refactor) keep compiling. It uses
// a module-level setter that PdfDownloadProvider populates on mount.
//
// Pages SHOULD prefer `usePdfDownload()` over importing this directly —
// the hook gives you a stable function reference + automatic cleanup.

let _impl = null;

export function _registerDownloadImpl(fn) {
  _impl = fn;
}

export async function downloadFile(url, filename, opts = {}) {
  if (!_impl) {
    console.warn("[downloadFile] called before PdfDownloadProvider mounted");
    return false;
  }
  return _impl(url, filename, opts);
}
